var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{staticClass:"dashboard",staticStyle:{"background-color":"#F0F0F0"},attrs:{"title":"Planlægning"}},[_c('button-group-view',{staticStyle:{"float":"left"},attrs:{"slot":"tools","actions":[
			{
				label: 'Kanban',
				value: 'kanban'
			},
			{
				label: 'Kort',
				value: 'map'
			}
		]},slot:"tools",model:{value:(_vm.view),callback:function ($$v) {_vm.view=$$v},expression:"view"}}),_c('button-view',{staticStyle:{"float":"left"},attrs:{"slot":"tools"},on:{"click":_vm.createTodo},slot:"tools"},[_vm._v("+ Todo")]),_c('button-view',{staticStyle:{"float":"left"},attrs:{"slot":"tools"},on:{"click":_vm.createJob},slot:"tools"},[_vm._v("+ Opgave")]),_c('button-view',{staticStyle:{"float":"left"},attrs:{"slot":"tools"},on:{"click":_vm.createCustomer},slot:"tools"},[_vm._v("+ Kunde")]),_c('div',{staticClass:"layout"},[_c('date-picker-std-view',{staticClass:"date",on:{"browse":_vm.updateState},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_c('plethora-tabs-view',{staticClass:"tabs",attrs:{"tabs":[
				{
					label: 'Opgaver',
					value: 'jobs',
					badge: {
						visible: _vm.tasks.length > 0,
						label: _vm.tasks.length
					}
				},
				{
					label: 'Todo',
					value: 'todo',
					badge: {
						visible: _vm.todos.length > 0,
						label: _vm.todos.length
					}
				}
			]},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}}),_c('perfect-scrollbar',{staticClass:"tasks",style:({
				transition: 'grid-row 250ms'
			}),attrs:{"name":"task","tag":"div"}},[_c('transition-group',{attrs:{"name":"task","tag":"div"}},[_vm._l((_vm._tasks),function(task,i){return _c('task-view',{key:i,staticClass:"task",attrs:{"task":task}})}),_vm._l((_vm._todos),function(todo,i){return _c('todo-view',{key:i,staticClass:"task",attrs:{"todo":todo}})})],2)],1),_c('kanban-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.view == 'kanban'),expression:"view == 'kanban'"}],staticClass:"list",attrs:{"users":_vm.users}}),_c('gmap-map',{directives:[{name:"show",rawName:"v-show",value:(_vm.view == 'map'),expression:"view == 'map'"}],ref:"map",staticClass:"list",attrs:{"center":{lat:10, lng:10},"zoom":7,"options":{ styles: _vm._map_style }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }